// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const AllyDownload = createSvgIcon(
  { All: <React.Fragment><path fill="currentColor" stroke="transparent" fillRule="evenodd" d="M5.88 24H0L11.999 7.244 24 24h-5.74c-1.063-2.195-3.434-3.724-6.19-3.724-2.755 0-5.127 1.529-6.19 3.724zM12 13.627c-1.578 0-2.858 1.19-2.858 2.66 0 1.469 1.28 2.66 2.858 2.66s2.857-1.191 2.857-2.66c0-1.47-1.28-2.66-2.857-2.66zm12-8.998h-3V0h-4v4.629h-3l5 7.714 5-7.714z" clipRule="evenodd" /></React.Fragment>, },
  'default'
);
